import { PropsWithChildren, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useDeprecatedIntegratedEventQueueStore } from './use-deprecated-integrated-event-queue-store';
import { useDispatchAreaStore } from '../../dispatch-areas/use-dispatch-areas';
import { QueueStateContext } from '../../queues/context/queue-state-context';
import { WorkspacePanel } from '../../panels/workspace-panel';
import { useRegisterQueueStore } from '../../queues/queue-registry/use-register-queue-store';
import { workspacePanelIsQueue } from '../../panels/workspace-queue-exists';

export const DeprecatedEventQueueStateProvider = observer(
    function DeprecatedEventQueueStateProvider({
        workspacePanel,
        children,
    }: PropsWithChildren<{
        workspacePanel: WorkspacePanel;
    }>): React.ReactElement {
        workspacePanelIsQueue(workspacePanel);
        const { monitoredAndOwnedDispatchAreaIds: dispatchAreaIds } = useDispatchAreaStore();

        const eventQueueFilters = useMemo(() => {
            return workspacePanel.queue.eventQueueFilters ?? [];
        }, [workspacePanel.queue.eventQueueFilters]);

        const store = useDeprecatedIntegratedEventQueueStore({
            workspacePanel,
            dispatchAreaIds,
            eventQueueFilters,
        });

        useRegisterQueueStore(store);

        return <QueueStateContext.Provider value={store}>{children}</QueueStateContext.Provider>;
    }
);
